import { useQuery } from "@tanstack/react-query";
import { buildGlossaryLookup, type GlossaryLookup } from "@/lib/metric-description";

interface GlossaryApiChild {
  value: string;
  spokenForm?: string | null;
  definition?: string | null;
}

interface GlossaryApiTerm {
  category: string;
  children?: GlossaryApiChild[];
}

interface GlossaryApiResponse {
  terms: GlossaryApiTerm[];
}

const EMPTY_LOOKUP: GlossaryLookup = new Map();

export function useGlossaryLookup(): GlossaryLookup {
  const { data } = useQuery<GlossaryApiResponse>({
    queryKey: ["/api/glossary"],
    queryFn: async () => {
      const res = await fetch("/api/glossary", { credentials: "include" });
      if (!res.ok) throw new Error("Failed to fetch glossary");
      return res.json();
    },
    staleTime: 10 * 60 * 1000,
  });

  if (!data?.terms) return EMPTY_LOOKUP;
  return buildGlossaryLookup(data.terms);
}
